import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { CardImg, CardBody, Row, Col } from "reactstrap";
import { getCacheImage } from "../../config";
import { emptyImage } from "../../utils";
import fireIcon from "../../images/fire-product.png"

const onErrorImg = (e, category) => {
  e.target.src = emptyImage(category)
}
export default class SneakerImage extends Component {
  render() {
    const url_origin = this.props.hasImage
      ? getCacheImage(this.props.src)
      : emptyImage(this.props.category);

    return (
      <CardBody className="img-sneaker">
        <Row>
          <Col>
            {
              this.props.hotProducts && (
                <KickImage src={fireIcon} alt="hot product" className="sneaker-item__hot-product" />
              )
            }
            <CardImg 
              src={url_origin} 
              alt={this.props.alt}
              onError={(e) => onErrorImg(e, this.props.category)} />
          </Col>
        </Row>
      </CardBody>
    );
  }
}
